export default __webpack_public_path__ + "static/media/iconHomeNews.9382f428.svg";